import type { Observable } from 'rxjs';
import type { HttpDataResponse } from '@common/types/http-response.type';
import type { EduCourseTariff } from '@common/types/edu-course.type';

import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class EduCoursesTariffsHttpService extends BaseHttpService {
    public getEduCoursesTariffs(): Observable<EduCourseTariff[]> {
        return this.http.get<HttpDataResponse<EduCourseTariff[]>>(this.formatEduServiceApiUrl(`courses/tariffs`)).pipe(
            shareReplay(),
            map((data) => data.data)
        );
    }
}
